<div class="header">
  <div class="title">Save Layout</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="saveTemplateForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-col mt-3">
    <div class="font-medium mb-2">How would you like to save the layout?</div>
    <mat-radio-group class="flex flex-col" [color]="'primary'" [formControlName]="'apply_layout'">
      <mat-radio-button class="mb-2" [value]="'update'">
        Update existing layout [{{ projectTemplate.name }}]. This will apply to other
        {{ relatedToType === 'Property' ? 'properties' : 'deals' }} using this layout.
      </mat-radio-button>
      <mat-radio-button [value]="'create'">
        Create a new layout and apply to this {{ relatedToType === 'Property' ? 'property' : 'deal' }}.
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-8" *ngIf="saveTemplateForm.get('apply_layout').value == 'create'">
    <mat-form-field class="subject flex-auto">
      <mat-label>What should we call this new template?</mat-label>
      <input matInput placeholder="Template Name" [formControlName]="'name'" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="
          saveTemplateForm.invalid ||
          (saveTemplateForm.get('apply_layout').value == 'create' && !saveTemplateForm.get('name').value)
        "
        (click)="save()"
      >
        <span *ngIf="!saveTemplateForm.disabled">Save</span>
        <mat-progress-spinner *ngIf="saveTemplateForm.disabled" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
